// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TUpdateConfigRequest,
  TUpdateConfigModel,
  IMappers,
  TUpdateConfigResponse,
  TUpdateConfigResponse_1,
  TUpdateConfigResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TUpdateConfigModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'promotions-flow-control',
  pathApi: '/v1/update-config/',
  requestType: 'json',
  interserviceAuthEnabled: true,
} as TUpdateConfigModel;

export function createUpdateConfigModel(parameters: TUpdateConfigRequest): TUpdateConfigModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IUpdateConfigOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TUpdateConfigRequest;
}

export async function fetchUpdateConfig<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IUpdateConfigOptions<TResponse200, TResponse400>): Promise<TUpdateConfigResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createUpdateConfigModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TUpdateConfigResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TUpdateConfigResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TUpdateConfigResponse;
}
